import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Container, Section, SectionHeader } from '../../common';

// Styled wrapper to control overflow
const TableWrapper = styled.div`
  /* overflow-x: auto; */
`;

// Styled motion table with Tailwind grid layout
const Table = styled(motion.table)`
  /* @apply min-w-full divide-y divide-gray-100; */
`;

// Thead with dynamic background color
const Thead = styled.thead`
  background-color: ${(props) => props.$bgColor};
`;

// Th with white text
const Th = styled.th`
  /* @apply px-3 py-3.5 text-left text-sm font-semibold text-white; */
`;

// Tbody with static white background
const Tbody = styled.tbody`
  background-color: ${(props) => props.$bgColor};
`;

// Td with text styling
const Td = styled.td`
  /* @apply whitespace-nowrap px-3 py-4 text-lg text-gray-700; */
`;

const TableSection = ({ section, sanity }) => {
  const { header, columns, rows } = section;
  const { colors } = sanity;

  return (
    <Section
      idName="table-section"
      bgColor={colors?.neutral?.lighter}
      h2Color={colors?.neutral?.darker}
      classes="bg-gradient-to-br from-gray-300 to-white"
    >
      <Container padding="none" classes="max-w-4xl px-4">
        <SectionHeader
          sanity={sanity}
          tagline={header?.tagline}
          headline={header?.headline}
          description={header?._rawDescription}
        />
        <TableWrapper className="mt-8 overflow-x-auto shadow-2xl rounded-2xl">
          <Table
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
            viewport={{ once: true }}
            className="table w-full divide-y divide-gray-300 table-fixed"
          >
            <Thead $bgColor={colors?.primary?.default}>
              <tr>
                {columns?.map((col, i) => (
                  <Th
                    className="px-3 py-3.5 text-left text-lg lg:text-2xl font-semibold text-white"
                    key={`header-${i}`}
                  >
                    {col}
                  </Th>
                ))}
              </tr>
            </Thead>
            <Tbody $bgColor={colors?.neutral?.white}>
              {rows?.map((row, rowIndex) => (
                <tr
                  key={`row-${rowIndex}`}
                  className={
                    rowIndex % 2 === 0
                      ? 'bg-white transition duration-200 hover:bg-gray-200'
                      : 'bg-gray-100 transition duration-200 hover:bg-gray-200'
                  }
                >
                  {row?.values?.map((cell, cellIndex) => (
                    <Td
                      className={`px-4 py-4 text-lg align-top text-gray-700 ${cellIndex === 0 ? 'font-semibold text-gray-900' : 'italic'}`}
                      key={`cell-${rowIndex}-${cellIndex}`}
                    >
                      {cell}
                    </Td>
                  ))}
                </tr>
              ))}
            </Tbody>
          </Table>
        </TableWrapper>
      </Container>
    </Section>
  );
};

export { TableSection };
